// Student Settings → "Save changes" (exam prep target, theme, accent, text
// size, font, stickers).
// Save is only offered when one of these differs from what's saved, so the
// button no longer PUTs and toasts "Saved!" when nothing changed.
import { DEFAULT_THEME_ID } from './themes';

/** The saved look, in the page's own state shape (same defaults it uses). */
export function savedLookPrefs(profile = {}) {
  return {
    themeId: profile.theme_id || DEFAULT_THEME_ID,
    accent: profile.accent_color || '',
    fontScale: profile.font_scale || 'md',
    fontOverride: profile.font_override || '',
    stickers: profile.stickers || [],
  };
}

const sameStickers = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((id) => set.has(id));
};

/** The saved Exam Prep target ('' = none). */
export const savedTargetExam = (profile = {}) => profile.target_exam || '';

/** Exam Prep tap: pick an exam, or tap the selected one again to clear it. */
export const nextTargetExam = (current, tapped) => (current === tapped ? '' : tapped);

/** True when the current picks differ from the saved look. */
export function hasUnsavedLookChanges(saved, current) {
  return saved.themeId !== current.themeId
    || saved.accent !== current.accent
    || saved.fontScale !== current.fontScale
    || saved.fontOverride !== current.fontOverride
    || !sameStickers(saved.stickers, current.stickers);
}
